
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_1lo8e_93",
  "refresh": "awsui_refresh_2qdw9_1lo8e_111",
  "root-no-actions": "awsui_root-no-actions_2qdw9_1lo8e_114",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_1lo8e_114",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_1lo8e_114",
  "root-has-description": "awsui_root-has-description_2qdw9_1lo8e_114",
  "root-no-wrap": "awsui_root-no-wrap_2qdw9_1lo8e_120",
  "main": "awsui_main_2qdw9_1lo8e_124",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_1lo8e_132",
  "main-variant-h2": "awsui_main-variant-h2_2qdw9_1lo8e_139",
  "main-variant-h3": "awsui_main-variant-h3_2qdw9_1lo8e_139",
  "actions": "awsui_actions_2qdw9_1lo8e_149",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_1lo8e_153",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_1lo8e_156",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_1lo8e_159",
  "title": "awsui_title_2qdw9_1lo8e_172",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_1lo8e_178",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_1lo8e_184",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_1lo8e_190",
  "info": "awsui_info_2qdw9_1lo8e_200",
  "description": "awsui_description_2qdw9_1lo8e_204",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_1lo8e_209",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_1lo8e_216",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_1lo8e_223",
  "heading": "awsui_heading_2qdw9_1lo8e_232",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_1lo8e_241",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_1lo8e_246",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_1lo8e_251",
  "heading-text": "awsui_heading-text_2qdw9_1lo8e_257",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_1lo8e_260",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_1lo8e_268",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_1lo8e_276",
  "counter": "awsui_counter_2qdw9_1lo8e_285"
};
  